import React, { useState } from 'react';
import './number-field.styles.css';

const NumberField = () => {
  const [count, setCount] = useState(1);

  const increase = () => {
    setCount(count + 1);
  };

  const decrease = () => {
    if (count > 0) {  // جلوگیری از منفی شدن
      setCount(count - 1);
    }
  };

  return (
    <div className="number-field">
      <button className="decrease number-field-button" onClick={decrease}>-</button>
      <input
        type="text"
        value={count}
        readOnly
        className="number-input"
      />
      <button className="increase number-field-button" onClick={increase}>+</button>
    </div>
  );
};

export default NumberField;
